import { render, staticRenderFns } from "./pendingRequests.vue?vue&type=template&id=773e38f8&scoped=true&"
import script from "./pendingRequests.vue?vue&type=script&lang=js&"
export * from "./pendingRequests.vue?vue&type=script&lang=js&"
import style0 from "./pendingRequests.vue?vue&type=style&index=0&id=773e38f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e38f8",
  null
  
)

export default component.exports